import styled from "styled-components";
import theme from "../common/theme";

export const ButtonBase = styled.button`
    background-color: transparent;
    color: ${theme.palette.dark};
    border: 1px solid transparent;
    font-size: 14px;
    font-weight: 700;
    font-family: Roboto Condensed;
    cursor: pointer;
    padding: 1rem 2rem;
    text-transform: uppercase;
    opacity: ${props => props.disabled ? '0.12' : '1'};
    align-items: center;
    justify-content: center;
    display: flex;
    user-select: none;

    &:hover {        
        opacity: ${props => props.disabled ? '0.12' : '0.7'};
    }    
`
export const WhiteButton = styled(ButtonBase)`
    background-color: #fff;
    color: black;
    gap: 0.5rem;
    border: 1px solid #000;
    `

export const LightButton = styled(ButtonBase)`
    background-color: ${theme.palette.light};
    color: black;
    gap: 0.5rem;
    `

export const DarkButton = styled(ButtonBase)`
    background-color: ${theme.palette.dark};
    color: white;
    gap: 0.5rem;
`

export const BlackButton = styled(ButtonBase)`
    background-color: #000;
    color: white;
    gap: 0.5rem;
`